import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from 'chart.js';
import '../GuruTradesChart/GuruTradesChart.css'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement);

const GuruTradesChart = () => {
  // Sample data
  const data = {
    labels: ['2024-12-01', '2024-12-02', '2024-12-03', '2024-12-04', '2024-12-05', '2024-12-06', '2024-12-07', '2024-12-08', '2024-12-09', '2024-12-10', '2024-12-11', '2024-12-12'],
    datasets: [
      {
        label: 'Cash',
        data: [10, 15, 6, 8, 12, 14, 11, 7, 11, 13, 12, 10], // Cash count
        backgroundColor: '#33a853', // Green bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
      {
        label: 'Debt',
        data: [9, 8, 7, 5, 4, 6, 9, 9, 6, 5, 10, 9], // Debt count
        backgroundColor:' #ea4336', // Red bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
    ],
    
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Debt & Cash Comparison',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'white', // White background
        titleColor: 'black', // Title text color (you can change this if needed)
        bodyColor: 'black', // Body text color
        borderColor: 'black', // Border color
        borderWidth: 1, // Border width
        padding: 10, // Padding inside the tooltip
        caretSize: 5, // Size of the tooltip's arrow/caret
        cornerRadius: 4, // Rounded corners for the tooltip
      },
    },
    scales: {
      y: {
        display: false,
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Value (in Millions)',
        },
        ticks: {
          callback: function (value) {
            return value + 'M';
          },
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
        },
      },
    },
  };

  return (
    <div className='trade-container'>
      <h2>Debt & Cash Comparison</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default GuruTradesChart;
